var map = {
	"./Barbecue.png": 9560,
	"./Bread.png": 7403,
	"./Burger.png": 7282,
	"./Cake.png": 7717,
	"./Chicken.png": 3120,
	"./Coffee.png": 9053,
	"./Current Time.png": 6583,
	"./Cutlery.png": 9939,
	"./Fast Food.png": 2499,
	"./Fries.png": 4312,
	"./Kakanin.png": 9569,
	"./Mixed Soda.png": 1217,
	"./New.png": 7315,
	"./No Fast Food.png": 6298,
	"./No Store.png": 3059,
	"./Other.png": 7127,
	"./Pastry.png": 7814,
	"./Pizza.png": 3083,
	"./Ramen.png": 6044,
	"./Rice Meal.png": 7305,
	"./Sea Foods.png": 8023,
	"./Sea Snail.png": 5083,
	"./Soup.png": 4524,
	"./Store.png": 894,
	"./Street Foods.png": 7119,
	"./Street Shop.png": 4858,
	"./Takoyaki.png": 3084,
	"./Tea.png": 2275,
	"./Vegetables.png": 3985,
	"./Waffle.png": 8852
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2328;